import clsx from "clsx";

import { PRICING_PLANS } from "common/constants";

type IconSize = "sm" | "md" | "lg";

const colorClassName: Record<keyof typeof PRICING_PLANS, string[]> = {
  agency: [
    "[background:linear-gradient(345deg,#030712_0.73%,#4515BE_34.15%,#642CFF_53.76%,#8A7AFF_90.47%),linear-gradient(348deg,#4515BE_9.77%,#642CFF_58.54%,#8A7AFF_100.85%)]",
    "[background-blend-mode:hard-light,normal,normal]",
    "[box-shadow:0_0_1.667px_1.667px_rgba(255,255,255,0.16)_inset,0_2.5px_5px_1.667px_rgba(17,24,39,0.20),_0_0_0_3.333px_rgba(243,244,246,0.50),0_23.333px_16.667px_0_rgba(224,225,255,0.70),_0_11.667px_8.333px_0_rgba(119,85,255,0.30)]",
  ],
  outreach: [
    "[background:radial-gradient(166.06%_127.08%_at_50%_93.75%,rgba(255,255,255,0)_25%,rgba(255,255,255,0.20)_52.8%,#fff_100%),linear-gradient(348deg,#C63906_-2.57%,#FF4D00_47.65%,#FF8E42_100.85%),linear-gradient(348deg,#4515BE_9.77%,#642CFF_58.54%,#8A7AFF_100.85%)]",
    "[background-blend-mode:hard-light,normal,normal]",
    "[box-shadow:0_0_2px_2px_rgba(255,255,255,0.16)_inset,0_0_0_4px_rgba(246,244,243,0.80),0_14px_14px_0_rgba(255,142,66,0.20)]",
  ],
  avatar: [
    "[background:radial-gradient(166.06%_127.08%_at_50%_93.75%,rgba(255,255,255,0.00)_25%,rgba(255,255,255,0.20)_52.8%,#FFF_100%),linear-gradient(348deg,#4515BE_9.77%,#642CFF_58.54%,#8A7AFF_100.85%)]",
    "[background-blend-mode:hard-light,normal]",
    "[box-shadow:0_0_2.333px_2.333px_rgba(255,255,255,0.16)_inset,0_3.5px_7px_2.333px_rgba(17,24,39,0.20),0_0_0_4.667px_rgba(243,244,246,0.50),0_32.667px_23.333px_0_rgba(224,225,255,0.70)]",
  ],
};

const containerSizeMap: Record<IconSize, string> = {
  sm: "size-10",
  md: "size-12",
  lg: "size-14",
};

const iconSizeMap: Record<IconSize, string> = {
  sm: "size-5",
  md: "size-6",
  lg: "size-7",
};

export default function SubscriptionPlanIcon({
  size,
  plan,
}: {
  size: IconSize;
  plan: keyof typeof PRICING_PLANS;
}) {
  const { icon: Icon } = PRICING_PLANS[plan];

  return (
    <span
      className={clsx(
        "shrink-0 rounded-2xl inline-flex items-center justify-center",
        containerSizeMap[size],
        colorClassName[plan],
      )}
    >
      <Icon className={clsx(iconSizeMap[size])} />
    </span>
  );
}
